/**
 * The offline copy: Osprey as one HTML file (scripts/build-offline.js writes build/osprey-offline.html,
 * which admins download from Home). That file sets `window.__OSPREY_OFFLINE__` before the app runs.
 *
 * In it nothing goes to Firebase: Submit saves on this device and exports to the USB folder (and the
 * Pi, when one is set and reachable), and the QR code works as always. No service worker either - a
 * file opened from disk has no server to update from.
 */
export const OFFLINE_COPY = typeof window !== 'undefined' && window.__OSPREY_OFFLINE__ === true;

/** Why the offline copy doesn't upload: what uploadBlocker returns, so every upload path says the same. */
export const OFFLINE_UPLOAD_NOTE = 'Offline copy of Osprey: saved on this device. Send it with the QR code or the USB folder.';

/** Where the deployed site serves the file (scripts/build-offline.js). */
export const OFFLINE_FILE_URL = '/osprey-offline.html';
